import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
import { GiThermometerScale } from 'react-icons/gi';

const tiles = [
  {
    sNo: 1,
    link: '/common/instrumentMasterlist?instrument_doc_type=FINAL',
    isLink: true,
    icon: <GiThermometerScale size="5rem" color="#343a40" />,
    p: 'List of',
    span: 'Instrument',
    isIcon: true,
  },
  // {
  //   sNo: 1,
  //   link: '/common/instrumentMasterlist?instrument_doc_type=RSZNG',
  //   isLink: true,
  //   icon: <GiThermometerScale size="5rem" color="#343a40" />,
  //   p: 'List of',
  //   span: 'Instrument (RSZNG)',
  //   isIcon: true,
  // },
  // {
  //   sNo: 1,
  //   link: '/common/instrumentMasterlist?instrument_doc_type=MS',
  //   isLink: true,
  //   icon: <GiThermometerScale size="5rem" color="#343a40" />,
  //   p: 'List of',
  //   span: 'Instrument (MS)',
  //   isIcon: true,
  // },
  // {
  //   sNo: 1,
  //   link: '/common/instrumentMasterlist?instrument_doc_type=LS',
  //   isLink: true,
  //   icon: <GiThermometerScale size="5rem" color="#343a40" />,
  //   p: 'List of',
  //   span: 'Instrument (LS)',
  //   isIcon: true,
  // },
  // {
  //   sNo: 1,
  //   link: '/common/instrumentMasterlist?instrument_doc_type=OKINST',
  //   isLink: true,
  //   icon: <GiThermometerScale size="5rem" color="#343a40" />,
  //   p: 'List of',
  //   span: 'Instrument (OK INST)',
  //   isIcon: true,
  // },
];

const InstrumentsTiles = () => {
  return (
    <>
      <ChildHeader text="CALLIBRATION PLAN" />
      <RenderTiles
        tilesObj={tiles}
        height="100vh"
        justify="start"
        columns="0"
      />
    </>
  );
};

export default InstrumentsTiles;
